import { TableComponent } from './components/table/table.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from './pipes/pipes.module';
import { NgModule, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LoadingComponent } from './components/loading/loading.component';
import { LoadingFieldComponent } from './components/loading-field/loading-field.component';
import { TableCheckboxComponent } from './components/table-checkbox/table-checkbox.component';
import { GoogleChartsComponent } from './components/google-charts/google-charts.component';
import { TableForFilterComponent } from './components/table-checkbox/table-for-filter/table-for-filter.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { ExpansivePanelComponent } from './components/expansive-panel/expansive-panel.component';
import { DatePickerComponent } from './components/inputs/date-picker/date-picker.component';
import { InputSelectComponentLEGADO } from './components/inputs/input-select/input-select.component';
import { RadioButtonComponent } from './components/inputs/radio-button/radio-button.component';
import { CheckboxButtonComponent } from './components/inputs/checkbox-button/checkbox-button.component';
import { TitleComponent } from './components/title/title.component';
import { SquareButtonComponent } from './components/buttons/add-edit-square-button/square-button.component';
import { TextAreaComponent } from './components/inputs/text-area/text-area.component';
import { InputTextComponent } from './components/inputs/input-text/input-text.component';
import { ButtonComponent } from './components/buttons/button/button.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { DropdownComponent } from './components/header/components/dropdown/dropdown.component';
import { CloseIconComponent } from './components/buttons/close-icon/close-icon.component';
import { MicrophoneComponent } from './components/microphone/microphone.component';
import { TableWithTitleComponent } from './components/table-with-title/table-with-title.component';
import { ExpansionPanelComponent } from './components/combo-text-area-with-title/components/expansion-panel/expansion-panel.component';
import { ComboTextAreaWithTitleComponent } from './components/combo-text-area-with-title/combo-text-area-with-title.component';
import { ChipsWithCategoryComponent } from './components/chips-with-category/chips-with-category.component';
import { GreyRectangleComponent } from './components/combo-text-area-with-title/components/grey-rectangle/grey-rectangle.component';
import { PatientSearchDropDownComponent } from './components/header/components/patient-search-drop-down/patient-search-drop-down.component';
import { PopUpHeaderComponent } from './components/pop-up/pop-up-header/pop-up-header.component';
import { PopUpFooterComponent } from './components/pop-up/pop-up-footer/pop-up-footer.component';
import { IncludeFirstQuestionnaireComponent } from './components/include-first-questionnaire/include-first-questionnaire.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { LastRecordsComponent } from './components/last-records/last-records.component';
import { HistoryCardComponent } from './components/history-card/history-card.component';
import { DropdownWaitingRoomComponent } from './components/header/components/dropdown-waiting-room/dropdown-waiting-room.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SimpleInputComponent } from './components/inputs/simple-input/simple-input.component';
import { InputDropdownComponent } from './components/inputs/input-dropdown/input-dropdown.component';
import { InputTextFieldComponent } from './components/inputs/input-text-field/input-text-field.component';
import { DeepKeyPipe } from './pipes/deep-key.pipe';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { ReplacePipe } from './pipes/replace.pipe';
import { RemoveSquereBtnComponent } from './components/buttons/remove-squere-btn/remove-squere-btn.component';
import { BaseBtnComponent } from './components/buttons/base-btn/base-btn.component';
import { FormGroupInputsComponent } from './components/inputs/form-group-inputs/form-group-inputs.component';
import { CheckboxMultipleButtonsComponent } from './components/inputs/checkbox-multiple-buttons/checkbox-multiple-buttons.component';
import { IsQuestionEmptyPipe, IsTextEmptyPipe } from './pipes/is-text-empty.pipe';
import { ShowBtnBodyPipe } from './components/table/show-btn-body.pipe';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { IsSameDatePipe, IsTodayPipe } from './pipes/is-same-date-pipe';
import { InfoContainerComponent } from './components/info-container/info-container.component';
import { InputWithFilterComponent } from './components/inputs/input-with-filter/input-with-filter.component';
import { NgxMaskModule } from 'ngx-mask';
import { LabelBoxDirective } from './directives/label-box/label-box.directive';
import { FormVMContainerDirective } from './forms/form-vm-container.directive';
import { FormFieldDirective } from './forms/form-field.directive';
import { DebuggerDirective } from './devmode/debugger.directive';
import { DateToInvertedString } from './pipes/date-to-inverted-string.pipe';
import { AddMedicationsInUseComponent } from './dialogs/medications-in-use/add-medications-in-use/add-medications-in-use.component';
import { SelectedMedicationsInUseComponent } from './selected-medications-in-use/selected-medications-in-use.component';
import { RadioButtonGroupComponent } from './components/inputs/radio-button-group/radio-button-group.component';
import { FiedRequiredComponent } from './directives/fied-required/fied-required.component';
import { SubFormContainerDirective } from './forms/sub-form-container/sub-form-container.directive';
import { CheckboxYesNoComponent } from './components/inputs/checkbox-button/checkbox-yes-no/checkbox-yes-no.component';
import { SelectedAllergiesComponent } from './dialogs/allergies/selected-allergies/selected-allergies.component';
import { AllergiesComponent } from './dialogs/allergies/allergies-dialog/allergies.component';
import { SearchMedicationsComponent } from './dialogs/medications-in-use/search-medications/search-medications.component';
import { CmpTableWithCheckboxComponent } from './dialogs/allergies/table-with-checkbox/table-with-checkbox.component';
import { SearchInputComponent } from './components/header/components/search-input/search-input.component';
import { MinDateDirective } from './directives/input-date/min-date.directive';
import { MaxDateDirective } from './directives/input-date/max-date.directive';
import { PatientAllergiesComponent } from './components/allergies/patient-allergies/patient-allergies.component';
import { PatientSelectedAllergiesComponent } from './components/allergies/patient-selected-allergies/patient-selected-allergies.component';
import { TranslateAnswersPipe } from './pipes/translate-answers.pipe';
import { ReplaceNewLinePipe } from './pipes/replace-new-line.pipe';
import { SkipLinePipePipe } from './pipes/skip-line-pipe.pipe';

@NgModule({
  declarations: [
    LoadingComponent,
    LoadingFieldComponent,
    TableCheckboxComponent,
    GoogleChartsComponent,
    TabsComponent,
    SearchFieldComponent,
    TableForFilterComponent,
    TableComponent,
    ExpansivePanelComponent,
    DatePickerComponent,
    InputSelectComponentLEGADO,
    TableComponent,
    RadioButtonComponent,
    CheckboxButtonComponent,
    CheckboxYesNoComponent,
    TitleComponent,
    SquareButtonComponent,
    BaseBtnComponent,
    TextAreaComponent,
    InputTextComponent,
    ButtonComponent,
    FooterComponent,
    HeaderComponent,
    DropdownComponent,
    CloseIconComponent,
    MicrophoneComponent,
    TableWithTitleComponent,
    ExpansionPanelComponent,
    ComboTextAreaWithTitleComponent,
    ChipsWithCategoryComponent,
    GreyRectangleComponent,
    PatientSearchDropDownComponent,
    PopUpHeaderComponent,
    PopUpFooterComponent,
    IncludeFirstQuestionnaireComponent,
    PopUpComponent,
    LastRecordsComponent,
    HistoryCardComponent,
    DropdownWaitingRoomComponent,
    LogoutComponent,
    SimpleInputComponent,
    InputDropdownComponent,
    InputTextFieldComponent,
    DeepKeyPipe,
    AutoCompleteComponent,
    ReplacePipe,
    RemoveSquereBtnComponent,
    FormGroupInputsComponent,
    CheckboxMultipleButtonsComponent,
    ShowBtnBodyPipe,
    FormFieldComponent,
    InfoContainerComponent,
    InputWithFilterComponent,
    LabelBoxDirective,
    FormVMContainerDirective,
    FormFieldDirective,
    DebuggerDirective,
    AddMedicationsInUseComponent,
    SelectedMedicationsInUseComponent,
    RadioButtonGroupComponent,
    FiedRequiredComponent,
    AllergiesComponent,
    SelectedAllergiesComponent,
    CmpTableWithCheckboxComponent,
    SearchInputComponent,
    SearchMedicationsComponent,
    CmpTableWithCheckboxComponent,
    MinDateDirective,
    MaxDateDirective,
    PatientAllergiesComponent,
    PatientSelectedAllergiesComponent,
    TranslateAnswersPipe,
    ReplaceNewLinePipe,
    SkipLinePipePipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    DateToInvertedString,
    HttpClientModule,
    PipesModule,
    FormsModule,
    SubFormContainerDirective,
    TranslateModule.forRoot(),
    NgxMaskModule.forRoot(),
  ],
  exports: [
    CommonModule,
    FiedRequiredComponent,
    MaterialModule,
    RadioButtonGroupComponent,
    ReactiveFormsModule,
    HttpClientModule,
    PipesModule,
    FormFieldDirective,
    LoadingComponent,
    FormsModule,
    LoadingFieldComponent,
    TableCheckboxComponent,
    GoogleChartsComponent,
    TranslateModule,
    TabsComponent,
    DebuggerDirective,
    SearchFieldComponent,
    TableComponent,
    FormFieldComponent,
    TableForFilterComponent,
    ExpansivePanelComponent,
    DatePickerComponent,
    InputSelectComponentLEGADO,
    RadioButtonComponent,
    CheckboxButtonComponent,
    CheckboxMultipleButtonsComponent,
    CheckboxYesNoComponent,
    TitleComponent,
    SquareButtonComponent,
    BaseBtnComponent,
    TextAreaComponent,
    InputTextComponent,
    ButtonComponent,
    FooterComponent,
    HeaderComponent,
    DropdownComponent,
    CloseIconComponent,
    RemoveSquereBtnComponent,
    LabelBoxDirective,
    MicrophoneComponent,
    TableWithTitleComponent,
    ExpansionPanelComponent,
    ComboTextAreaWithTitleComponent,
    FormVMContainerDirective,
    ChipsWithCategoryComponent,
    GreyRectangleComponent,
    PatientSearchDropDownComponent,
    PopUpHeaderComponent,
    PopUpFooterComponent,
    IncludeFirstQuestionnaireComponent,
    PopUpComponent,
    LastRecordsComponent,
    HistoryCardComponent,
    LogoutComponent,
    SimpleInputComponent,
    InputDropdownComponent,
    InputTextFieldComponent,
    DeepKeyPipe,
    AutoCompleteComponent,
    ReplacePipe,
    IsTextEmptyPipe,
    IsQuestionEmptyPipe,
    IsSameDatePipe,
    IsTodayPipe,
    InfoContainerComponent,
    InputWithFilterComponent,
    SelectedMedicationsInUseComponent,
    SelectedAllergiesComponent,
    AllergiesComponent,
    CmpTableWithCheckboxComponent,
    MinDateDirective,
    MaxDateDirective,
    PatientAllergiesComponent,
    PatientSelectedAllergiesComponent,
    TranslateAnswersPipe,
    ReplaceNewLinePipe,
    SkipLinePipePipe
  ]
})
export class SharedModule { }
